import { BaseData, BaseDataContent } from 'types/base.type'
import { CreasResponse, CreasType } from 'types/creas.type'
import { CreasFilterRequest } from '../types/search-creas.type'
import client from './client'

class CreasService {
  getByFilters = async (filters: CreasFilterRequest): Promise<BaseDataContent<CreasResponse[]>> => {
    const url = '/creas'

    return await client.get<BaseDataContent<CreasResponse[]>>(url, filters).then((res) => res)
  }

  getCreasByUser = async (): Promise<BaseData<CreasResponse[]>> => {
    const url = '/creas/usuario'

    return await client.get<BaseData<CreasResponse[]>>(url).then((res) => res)
  }

  create = async (request: CreasType): Promise<BaseData<CreasResponse>> => {
    const url = `/creas`

    return await client.post<BaseData<CreasResponse>>(url, request).then((res) => res)
  }

  update = async (id: string, request: CreasType): Promise<BaseData<CreasResponse>> => {
    const url = `/creas/${id}`

    return await client.put<BaseData<CreasResponse>>(url, request).then((res) => res)
  }

  findById = async (id?: string): Promise<BaseData<CreasResponse>> => {
    const url = `/creas/${id}`

    return await client.get<BaseData<CreasResponse>>(url).then((res) => res)
  }

  deleteById = async (id?: number): Promise<string> => {
    const url = `/creas/${id}`

    return await client.delete<string>(url)
  }
}

export default new CreasService()
